module.exports = __webpack_public_path__ + "static/[Salve]ation-0ca694b01622b4d7c699edfe82d469c3.png";